import { render, staticRenderFns } from "./WardContactNotes.vue?vue&type=template&id=4294948e&scoped=true&"
import script from "./WardContactNotes.vue?vue&type=script&lang=js&"
export * from "./WardContactNotes.vue?vue&type=script&lang=js&"
import style0 from "./WardContactNotes.vue?vue&type=style&index=0&id=4294948e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4294948e",
  null
  
)

export default component.exports